import React from "react";
import LoadingIndicator from "LoadingIndicator";
import { UserContextProvider, UserContext } from "UserContext";
import CounterReports from "CounterReports";

const App = () => {
  return (
    <UserContextProvider>
      <UserContext.Consumer>
        {({ loading }) => (loading ? <LoadingIndicator /> : <CounterReports />)}
      </UserContext.Consumer>
    </UserContextProvider>
  );
};

export default App;
